<app-popup-content>
    <div class="action-content">
        <div class="flex items-center justify-between gap-4">
            <div class="cursor-default flex-auto flex items-center justify-between gap-2">
                <div class="flex-auto">{{ translations.title }}</div>
                <div
                    *ngIf="statusTooltip !== null && actionType === 'filter'"
                    class="flex-none flex items-center gap-1 text-xs text-secondary"
                >
                    <fui-spinner *ngIf="statusTooltip.preloader" [size]="1" [thickness]="0.15"></fui-spinner>
                    {{ statusTooltip.text }}
                </div>
            </div>
            <fui-button
                (clickEvent)="close()"
                type="button-icon"
                icon="close"
                height="slim"
                color="flat"
                borderRadius="circle"
                class="flex-none"
            >
            </fui-button>
        </div>

        <div class="content">
            <div cdkDropList class="tiles" (cdkDropListDropped)="drop($event)">
                <div
                    cdkDrag
                    *ngFor="let group of dynamicForm.controls; let index = index"
                    class="tile"
                    [style.order]="order.get(index)"
                >
                    <div class="column-field">
                        <fui-icon
                            cdkDragHandle
                            [cdkDragHandleDisabled]="isRowDisabled(index)"
                            icon="drag-vertical"
                            class="cursor-grab"
                        ></fui-icon>
                        <div class="field-block">
                            <div class="field-first">
                                <fui-select
                                    [fieldGroup]="asFormGroup(group)"
                                    [fieldName]="'userColumnName'"
                                    [label]="translations.userColumnNameLabel"
                                    [itemService]="disabledStringNameItemService"
                                    [items]="userColumnNameOptions"
                                    [forceDisabled]="isRowDisabled(index)"
                                    [hint]="isGroupedBy(index) ? dictionary.t_action_group_hint : null"
                                    (changed)="handleUserColumnNameChange(index, $event?.id ?? '')"
                                ></fui-select>
                            </div>

                            <div class="field-second">
                                <ng-container *ngIf="sortOrderOrSearchFieldMap.get(index).type === 'input'">
                                    <fui-text-input
                                        [fieldGroup]="asFormGroup(group)"
                                        fieldName="sortOrderOrSearchValue"
                                        [label]="sortOrderOrSearchFieldMap.get(index).label"
                                        [maxLength]="255"
                                        [forceDisabled]="
                                            group.get('userColumnName').value === '' || isRowDisabled(index)
                                        "
                                        (changed)="debounceAction()"
                                    ></fui-text-input>
                                </ng-container>
                                <ng-container *ngIf="sortOrderOrSearchFieldMap.get(index).type === 'select'">
                                    <ng-container
                                        *ngIf="sortOrderOrSearchFieldMap.get(index).column_type !== 'boolean'"
                                    >
                                        <fui-select
                                            [fieldGroup]="asFormGroup(group)"
                                            [fieldName]="'sortOrderOrSearchValue'"
                                            [label]="sortOrderOrSearchFieldMap.get(index).label"
                                            [itemService]="disabledStringNameItemService"
                                            [items]="sortOrderOrSearchFieldMap.get(index).options"
                                            [forceDisabled]="
                                                group.get('userColumnName').value === '' || isRowDisabled(index)
                                            "
                                            [showClearButton]="false"
                                            (changed)="initAction()"
                                        ></fui-select>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="sortOrderOrSearchFieldMap.get(index).column_type === 'boolean'"
                                    >
                                        <fui-select
                                            [fieldGroup]="asFormGroup(group)"
                                            [fieldName]="'sortOrderOrSearchValue'"
                                            [label]="sortOrderOrSearchFieldMap.get(index).label"
                                            [itemService]="defaultIdNameItemService"
                                            [items]="booleanOptions"
                                            [forceDisabled]="
                                                group.get('userColumnName').value === '' || isRowDisabled(index)
                                            "
                                            (changed)="initAction()"
                                        ></fui-select>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="button-block">
                            <fui-button
                                (clickEvent)="clickButton('remove', index)"
                                [title]="dictionary.system_del"
                                type="button-icon"
                                icon="delete-outline"
                                height="slim"
                                color="flat"
                                borderRadius="circle"
                                [disabled]="isRowDisabled(index)"
                            >
                            </fui-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <ng-container *ngFor="let button of footerButtons$ | async">
                <fui-button
                    (clickEvent)="clickButton(button.click)"
                    [label]="button.name"
                    [icon]="button.icon"
                    [color]="button.color"
                    [disabled]="button?.disabled"
                    height="slim"
                    type="button-long"
                >
                </fui-button>
            </ng-container>
        </div>
    </div>
</app-popup-content>
